import {emptyGuid} from "@utilities/commonUtilities";
import {INVENTORY_STATUS} from "../../loanLibraryConstants";

export const loanLibraryInventoryItemModel = ({
    loanLibraryInventoryId,
    loanLibraryCatalogItemId,
    copyNumber = 1,
    shelfLocation = '',
    serialNumber = '',
    assetNumber = '',
    notes = '',
    status = INVENTORY_STATUS.Available,
    catalogNumber = '',
    accessNumber = '',
    productName = '',
    author = '',
    mediaFormat = '',
    isForInternalUse = false,
    description = '',
    keywords = '',
    manufacturer = '',
    vendor = '',
    publicationDate = null,
    dateOfPurchase = null,
    recommendedQuantity = 0,
    cost = 0,
    relatedItems = '',
    loanTerms = '',
    accessoriesAndParts = '',
    shortId = '',
}: Record<string, unknown> = {}) => ({
    loanLibraryInventoryId: loanLibraryInventoryId || emptyGuid,
    loanLibraryCatalogItemId,
    copyNumber,
    shelfLocation,
    serialNumber,
    assetNumber,
    notes,
    status,
    catalogNumber,
    accessNumber,
    productName,
    author,
    mediaFormat,
    isForInternalUse,
    description,
    keywords,
    manufacturer,
    vendor,
    publicationDate,
    dateOfPurchase,
    recommendedQuantity,
    cost,
    relatedItems,
    loanTerms,
    accessoriesAndParts,
    shortId,
});

export const emptyLoanLibraryInventoryItemModel = loanLibraryInventoryItemModel();

